<template>
  <div class="tab-content">

    <el-tabs :value="value" @input="(val) => $emit('input', val)" @tab-click="handleClick">

      <!-- purchase -->
      <el-tab-pane :disabled="!projectPermission.viewSCMPurchasing" v-if="selectedRow.type === 'project'" :label="$t('project_tab_scm_purchasing')" name="purchaseProject">
        <purchaseProjectTable :projectPermission="projectPermission" :selectedRow="selectedRow" ref="purchaseProjectTable"/>
      </el-tab-pane>

      <el-tab-pane :disabled="!projectPermission.viewTaskSCMPurchasing" v-else :label="$t('project_tab_scm_purchasing')" name="purchaseTask">
        <purchaseTaskTable :projectPermission="projectPermission" :selectedRow="selectedRow" ref="purchaseTaskTable"/>
      </el-tab-pane>

      <!-- Purchasing Control -->
      <el-tab-pane :disabled="!projectPermission.viewSCMPurchasingControl" v-if="selectedRow.type === 'project'" :label="$t('project_tab_scm_purchasingControl')" name="purchasingControlProject">

          <el-tabs>
            <el-tab-pane :disabled="!projectPermission.createSCMPurchasingControlReceivingReports" :label="$t('project_tab_scm_purchasingControl_receivingReports')" name="receivingReportsProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createSCMPurchasingControlInspectionReports" :label="$t('project_tab_scm_purchasingControl_inspectionReports')" name="inspectionReportsProject">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>

      <el-tab-pane :disabled="!projectPermission.viewTaskSCMPurchasingControl" v-else :label="$t('project_tab_scm_purchasingControl')" name="purchasingControlTask">

          <el-tabs>
            <el-tab-pane :disabled="!projectPermission.createTaskSCMPurchasingControlReceivingReports" :label="$t('project_tab_scm_purchasingControl_receivingReports')" name="receivingReportsTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createTaskSCMPurchasingControlInspectionReports" :label="$t('project_tab_scm_purchasingControl_inspectionReports')" name="inspectionReportsTask">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>

      <!-- managing -->
      <el-tab-pane :disabled="!projectPermission.viewSCMManaging" v-if="selectedRow.type === 'project'" :label="$t('project_tab_scm_managing')" name="managingProject">

          <el-tabs>
            <el-tab-pane :disabled="!projectPermission.createSCMManagingVendorInvoice" :label="$t('project_tab_scm_managing_vendorInvoice')" name="vendorInvoiceProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createSCMManagingVendorReturns" :label="$t('project_tab_scm_managing_vendorReturns')" name="vendorReturnsProject">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createSCMManagingPurchaseCredits" :label="$t('project_tab_scm_managing_purchaseCredits')" name="purchaseCreditsProject">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>

      <el-tab-pane :disabled="!projectPermission.viewTaskSCMManaging" v-else :label="$t('project_tab_scm_managing')" name="managingTask">

          <el-tabs>
            <el-tab-pane :disabled="!projectPermission.createTaskSCMManagingVendorInvoice" :label="$t('project_tab_scm_managing_vendorInvoice')" name="vendorInvoiceTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createTaskSCMManagingVendorReturns" :label="$t('project_tab_scm_managing_vendorReturns')" name="vendorReturnsTask">
              Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :disabled="!projectPermission.createTaskSCMManagingPurchaseCredits" :label="$t('project_tab_scm_managing_purchaseCredits')" name="purchaseCreditsTask">
              Current Service Under Development
            </el-tab-pane>
          </el-tabs>

      </el-tab-pane>

      <!-- receive reports -->
      <!-- <el-tab-pane v-if="selectedRow.type === 'project'" label="Receive Reports" name="receiveReportsProject">
          Current Service Under Development
          (Receive Reports project)
      </el-tab-pane>
      <el-tab-pane v-else label="Receive Reports" name="receiveReportsTask">
          Current Service Under Development
          (Receive Reports)
      </el-tab-pane> -->

      <!-- inspection reports -->
      <!-- <el-tab-pane v-if="selectedRow.type === 'project'" label="Inspection Reports" name="inspectionReportsProject">
          Current Service Under Development
          (Inspection Reports project)
      </el-tab-pane>
      <el-tab-pane v-else label="Inspection Reports" name="inspectionReportsTask">
          Current Service Under Development
          (Inspection Reports)
      </el-tab-pane> -->

      <!-- request vendor invoice -->
      <!-- <el-tab-pane v-if="selectedRow.type === 'project'" label="Request Vendor Invoice" name="requestVendorInvoiceProject">
          Current Service Under Development
          (Request Vendor Invoice project)
      </el-tab-pane>
      <el-tab-pane v-else label="Request Vendor Invoice" name="requestVendorInvoiceTask">
          Current Service Under Development
          (Request Vendor Invoice Reports)
      </el-tab-pane> -->

      <!-- vendor invoice -->
      <!-- <el-tab-pane v-if="selectedRow.type === 'project'" label="Vendor Invoice" name="vendorInvoiceProject">
          Current Service Under Development
          (Vendor Invoice project)
      </el-tab-pane>
      <el-tab-pane v-else label="Vendor Invoice" name="vendorInvoiceTask">
          Current Service Under Development
          (Vendor Invoice Reports)
      </el-tab-pane> -->

    </el-tabs>

    <!-- bookmark -->
<!--    <div class="book-mark-block pointer" v-if="bookmarkList">-->
<!--      <div v-if="selectedRow.type === 'project'">-->
<!--        <div v-if="bookmarkListProject.scm" @click="changeBookMarkProject(bookmarkListProject.scm, $route.query.companyId, selectedRow.projectId)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--        <div v-else @click="changeBookMarkProject(bookmarkListProject.scm, $route.query.companyId, selectedRow.projectId)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--      </div>-->

<!--      <div v-else>-->
<!--        <div v-if="bookmarkList.scm" @click="changeBookMark(bookmarkList.scm, $route.query.companyId, selectedRow.projectId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--        <div v-else @click="changeBookMark(bookmarkList.scm, $route.query.companyId, selectedRow.projectId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--      </div>-->
<!--    </div>-->

  </div>
</template>

<script>
  import purchaseTaskTable from '@/components/Projects/accountTHINK/purchase/purchaseTaskTable.vue'
  import purchaseProjectTable from '@/components/Projects/accountTHINK/purchase/purchaseProjectTable.vue'
  import axios from 'axios'
  import moment from 'moment'

  export default {
    components: {
      purchaseTaskTable,
      purchaseProjectTable,
    },
    props: [
      'isProject',
      'selectedRow',
      'value',
      'bookmarkList',
      'bookmarkListProject',
      'projectPermission'
    ],
    data() {
      return {
        activeEstimateTab: '',
        activeStar: 'el-icon-star-on',
        notActiveStar: 'el-icon-star-off',
      }
    },
    methods: {
      handleClick(tab, event, projectTaskId) {
        // receive reports
        if(tab.label === "Receive Reports" && tab.name == "receiveReportsProject" && this.isProject){
          // dispatch
        }
        if(tab.label === "Receive Reports" && tab.name == "receiveReportsTask" && !this.isProject){
          // dispatch
        }

        // inspection reports
        if(tab.label === "Inspection Reports" && tab.name == "inspectionReportsProject" && this.isProject){
          // dispatch
        }
        if(tab.label === "Inspection Reports" && tab.name == "inspectionReportsTask" && !this.isProject){
          // dispatch
        }

        // request vendor invoice
        if(tab.label === "Request Vendor Invoice" && tab.name == "requestVendorInvoiceProject" && this.isProject){
          // dispatch
        }
        if(tab.label === "Request Vendor Invoice" && tab.name == "requestVendorInvoiceTask" && !this.isProject){
          // dispatch
        }

        // vendor invoice
        if(tab.label === "Vendor Invoice" && tab.name == "vendorInvoiceProject" && this.isProject){
          // dispatch
        }
        if(tab.label === "Vendor Invoice" && tab.name == "vendorInvoiceTask" && !this.isProject){
          // dispatch
        }

        // purchase
        if(tab.label === "Purchase" && tab.name == "purchaseProject" && this.isProject){
          let loader = this.$loading.show();
          this.$store.dispatch('getPurchaseList', {stateId: 'projectId',  id: this.selectedRow.projectId})
          loader.hide()
          // this.$refs.purchaseProjectTable.handleClick(tab, event, projectTaskId)
        }
        if(tab.label === "Purchase" && tab.name == "purchaseTask" && !this.isProject){
          // dispatch
          let loader = this.$loading.show();
          this.$store.dispatch('getPurchaseList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
          loader.hide()
          // this.$refs.purchaseTaskTable.handleClick(tab, event, projectTaskId)
        }
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      changeBookMark(state, companyid, projectId, taskId){
        let data = this.bookmarkList
        data.scm = !this.bookmarkList.scm
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/bookmarks/setProjectTask?companyId=${companyid}&projectId=${projectId}&projectTaskId=${taskId}`, data)
          .then(response => {
            if (this.bookmarkList.scm) {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
            } else {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
            }
          })
          .catch(error => {
          });
      },
      changeBookMarkProject(state, companyId, projectId, taskId){
        let data = this.bookmarkListProject
        data.scm = !this.bookmarkListProject.scm
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/bookmarks/setProject?companyId=${companyId}&projectId=${projectId}`, data)
          .then(response => {
            if (this.bookmarkListProject.scm) {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
            } else {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
            }
          })
          .catch(error => {
          });
      },
    }
  }
</script>

<style lang="scss" scoped>
// [ Modal ] end
.tab-content{
  position:relative;
  .book-mark-block{
    position:absolute;
    top:0;
    right:0;
    .el-checkbox__input{
      display:none;
    }
    .el-checkbox {
      border: none;
    }
    .el-checkbox__label{
      font-size:20px !important;
      color: #409EFF;
    }
  }
}
</style>
